/**
 * A component that displays a table of uepms/products that have been replaced by another uepm
 */
export const ChargeAccountProductJourneysTableComponent: ng.IComponentOptions = {
  bindings: {
    usageEventProductMappingId: '=',
    usageTokenLink: '='
  },
  templateUrl: 'app/angularJS/components/charge-account-product-journeys-table/charge-account-product-journeys-table.html',
  controller: 'ChargeAccountProductJourneysTableController',
  controllerAs: 'vm'
};